import { Directive, HostBinding } from '@angular/core';
import { CdkCell } from '@angular/cdk/table';

@Directive({
  selector: 'mcrai-td',
  host: {
    '[class.mcrai-td]': 'true'
  }
})
export class CellDirective extends CdkCell { }
